<template>
    <gcmcn-layout
        title="Feed Resource Overview"
    >
        <ns-loader
            ref="ns-loader"
            class="feed-resource-overview"
            :to-load="toLoad"
            @dataFetched="onDataFetched"
        >
            <ns-loader-spinner slot="loader"></ns-loader-spinner>
            <div slot="content">
                <gcmcn-filters
                    ref="gcmcn-filters"
                    :filter-values="[
                        selectedEntitiesForFilter,
                        selectedSortType,
                        searchFilter,
                    ]"
                    @reset-filters="resetFilters"
                >
                    <dropdown
                        name="Sort"
                        :multiple="false"
                        :list="$store.getters.sortTypeList"
                        itemName="name"
                        itemValue="value"
                        :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                        @on-select-item="selectedSortType = $event"
                    ></dropdown>
                    <dropdown
                        name="Entities"
                        :multiple="true"
                        :list="$store.getters.entities"
                        itemName="display_name"
                        itemValue="uid"
                        :itemsSelected="selectedEntitiesForFilter"
                        @on-select-item="onSelectEntities"
                    ></dropdown>
                    <dropdown
                        name="Universes"
                        :multiple="true"
                        :list="filteredUniverses"
                        itemName="display_name"
                        itemValue="uid"
                        :itemsSelected="selectedUniversesForFilter"
                        @on-select-item="onSelectUniverses"
                    ></dropdown>
                    <dropdown
                        name="Events"
                        :multiple="true"
                        :list="filteredEvents"
                        itemName="name"
                        itemValue="uid"
                        :itemsSelected="selectedEventsForFilter"
                        @on-select-item="onSelectEvents"
                    ></dropdown>
                    <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
                </gcmcn-filters>
                <div
                    v-for="entity in entitiesToDisplay"
                    :key="entity.uid"
                >
                    <feed-resource-overview
                        :entity="entity"
                        :feed-resources="feedResourcesToDisplay"
                        :feeds="feeds"
                        :filtered-events="filteredEvents"
                    ></feed-resource-overview>
                </div>
            </div>
        </ns-loader>
    </gcmcn-layout>
</template>

<script>
import GcmcnLayout from '@/components/partials/gcmcn-layout.vue';
import NsLoaderSpinner from '../../partials/ns-loader-template.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loaderV2.vue';
import { mapGetters } from 'vuex';
import FeedResourceOverview from './feed-resource-overview.vue';
import { Dropdown, SearchFilter, GcmcnFilters } from 'gcmcn-common';
export default {

    name: 'Index',

    components:{
        GcmcnLayout,
        NsLoader,
        FeedResourceOverview,
        NsLoaderSpinner,
        Dropdown,
        SearchFilter,
        GcmcnFilters,
    },

    data () {
        return {
            feeds: [],
            feedResources: [],
            events: [],
            universes: [],
            searchFilter: '',
            selectedSortType: 'asc',
        };
    },

    computed:{
        ...mapGetters([
            'entities',
            'selectedEntitiesForFilter',
            'selectedUniversesForFilter',
            'selectedEventsForFilter',
        ]),
        toLoad () {
            return [
                {
                    name: 'feedResources',
                    model: 'feedResources',
                    filters: {
                        archived: false,
                        status__in: 'RUNNING,STOPPED,STOP_REQUESTED,STOPPING',
                    }
                },
                {
                    name: 'feeds',
                    model: 'feeds',
                    filters:{
                        archived: false,
                        'status!': 'FINISHED',
                    }
                },
                {
                    name: 'events',
                    model: 'events',
                    filters: {
                        archived: false,
                    }
                },
                {
                    name: 'universes',
                    model: 'universes',
                    filters: {
                        archived: false,
                    }
                },
            ];
        },
        universeRelatedEntities() {
            return this.universes
                .filter(universe => this.selectedUniversesForFilter.includes(universe.uid))
                .map(universe => universe.scopes.entity_uid);
        },
        eventRelatedEntities(){
            return this.events
                .filter(event => this.selectedEventsForFilter.includes(event.uid))
                .map(event => event.scopes.entity_uid);
        },
        eventRelatedUniverses(){
            return this.events
                .filter(event => this.selectedEventsForFilter.includes(event.uid))
                .map(event => event.universe_uid);
        },
        entitiesToDisplay(){
            if(this.searchFilter){
                let searchFilter = this.searchFilter.toLowerCase();
                return this.entities
                .filter(
                    (entity) => entity.display_name.toLowerCase().includes(searchFilter)
                );
            }
            if(this.selectedEntitiesForFilter.length > 0){
                return this.entities.filter(
                    entity => this.selectedEntitiesForFilter
                        .includes(entity.uid)
                );
            }
            if(this.selectedUniversesForFilter.length > 0){
                return this.entities.filter(
                    entity => this.universeRelatedEntities
                        .includes(entity.uid)
                );
            }
            if(this.selectedEventsForFilter.length > 0){
                return this.entities.filter(
                    entity => this.eventRelatedEntities
                        .includes(entity.uid)
                );
            }
            if(this.selectedSortType){
                let ascendingEntities = this.entities.sort((a, b) => a.display_name.localeCompare(b.display_name));
                if(this.selectedSortType === 'dsc'){
                    let reverseEntities = this.entities.reverse();
                    return reverseEntities;
                }
                return ascendingEntities;
            }
            return this.entities;
        },
        feedResourcesToDisplay(){
            let feedResources = [...this.feedResources];
            if(this.selectedEntitiesForFilter.length > 0){
                feedResources = feedResources.filter(
                    feedResource => this.selectedEntitiesForFilter
                        .includes(feedResource.scopes.entity_uid)
                );
            }
            if(this.selectedUniversesForFilter.length > 0){
                feedResources = feedResources.filter(
                    feedResource => this.selectedUniversesForFilter
                        .includes(feedResource.universe_uid)
                );
            }
            if(this.selectedEventsForFilter.length > 0){
                feedResources = this.feedResources.filter(
                    feedResource => this.eventRelatedUniverses.includes(feedResource.universe_uid)
                );
            }
            return feedResources;
        },
        filteredUniverses(){
            if(this.selectedEntitiesForFilter.length > 0){
                let universes = [...this.universes];
                let filteredUniverses = universes.filter(universe=>{
                    return  this.selectedEntitiesForFilter.includes(universe.scopes.entity_uid);

                });
                return filteredUniverses;
            }
            return this.universes;
        },
        filteredEvents(){
            let filteredEvents = [...this.events];
            if(this.selectedEntitiesForFilter.length > 0){
                filteredEvents = filteredEvents.filter(event=>{
                    return  this.selectedEntitiesForFilter.includes(event.scopes.entity_uid);
                });
            }
            if(this.selectedUniversesForFilter.length > 0){
                // returns all event based on universe
                filteredEvents = filteredEvents.filter(event=>{
                    return  this.selectedUniversesForFilter.includes(event.universe_uid);
                });
            }
            return filteredEvents;
        },

    },

    methods:{
        onDataFetched (res){
            this.$set(this, 'feedResources', res.feedResources);
            let sortedFeeds = res.feeds.sort(this.sortingFeeds);
            this.$set(this, 'feeds', sortedFeeds);
            this.$set(this, 'events', res.events);
            this.$set(this, 'universes', res.universes);
        },
        onSelectEntities (entities) {
            this.$store.commit('SET_ENTITIES_FOR_FILTER', entities);
            // remove universe/events outside of scopes
            if(this.selectedUniversesForFilter.length > 0){
                let updatedUniverses = this.universes.filter(
                    universe => this.selectedUniversesForFilter.includes(universe.uid)
                        && entities.includes(universe.scopes.entity_uid)
                ).map(universe => universe.uid);
                this.$store.commit('SET_UNIVERSES_FOR_FILTER', updatedUniverses);
            }
            if(this.selectedEventsForFilter.length > 0){
                let updatedEvents = this.events.filter(
                    event => this.selectedEventsForFilter.includes(event.uid)
                        && entities.includes(event.scopes.entity_uid)
                ).map(event => event.uid);
                this.$store.commit('SET_EVENTS_FOR_FILTER', updatedEvents);
            }
        },
        onSelectUniverses (universes){
            this.$store.commit('SET_UNIVERSES_FOR_FILTER', universes);
            // remove events outside of scopes
            if(this.selectedEventsForFilter.length > 0){
                let updatedEvents = this.events.filter(
                    event => this.selectedEventsForFilter.includes(event.uid)
                        && universes.includes(event.universe_uid)
                ).map(event => event.uid);
                this.$store.commit('SET_EVENTS_FOR_FILTER', updatedEvents);
            }
        },
        onSelectEvents (events){
            this.$store.commit('SET_EVENTS_FOR_FILTER', events);
        },
        resetFilters (){
            this.$store.commit('CLEAR_ALL_FILTERS');
        },
        sortingFeeds(feed1, feed2) {
            if (feed1.confirmed && !feed2.confirmed) {
                return feed1.confirmed_start_date.localeCompare(feed2.start_date);
            } else if (!feed1.confirmed && feed2.confirmed) {
                return feed1.start_date.localeCompare(feed2.confirmed_start_date);
            } else if (feed1.confirmed && feed2.confirmed) {
                return feed1.confirmed_start_date.localeCompare(feed2.confirmed_start_date);
            } else {
                return feed1.start_date.localeCompare(feed2.start_date);
            }
        },
    }
};
</script>

<style lang="scss">
.feed-resource-overview{
    margin-top: 1em;
}
.no-item{
    color: #676565
}
</style>


// WEBPACK FOOTER //
// src/components/page/FeedResourcesOverview/index.vue